import { Button, ComposedModal, ModalBody, ModalFooter, ModalHeader } from "@carbon/react";
import FileUploader from "../FileUploader/index.js";

const EditAvatarModal = ({ 
    isOpen, 
    onClose, 
    onSave, 
    updateLoading,
    onFileChange 
}) => {
    return (
        <ComposedModal className="profile-modal" open={isOpen} onClose={onClose} size="md">
            <ModalHeader title="Editar Foto de Perfil" />
            <ModalBody>
                <FileUploader
                    types={['image/png', 'image/jpeg', 'image/jpg']}
                    item={''}
                    key={'profile-icon-edit'}
                    output={onFileChange}
                    inModal={true}
                />
            </ModalBody>
            <ModalFooter>
                <Button kind="danger" size="md" onClick={onClose}>
                    Cancelar
                </Button>
                <Button
                    kind="primary"
                    size="md"
                    disabled={updateLoading}
                    onClick={onSave}
                >
                    {updateLoading ? 'Guardando...' : 'Guardar'}
                </Button>
            </ModalFooter>
        </ComposedModal>
    );
};

export default EditAvatarModal;
